// Giriş yapmamış ziyaretçilerin ürün etkileşimlerini (görüntüleme, sepete
// ekleme, favori) takip edebilmek için tarayıcıya sabit bir anonim kimlik
// yazılır. Kullanıcı giriş yapınca bu oturumun geçmişi hesabına taşınır
// (activityAPI.merge) ve bu id yalnızca sunucudaki kayıtları eşlemek için
// kullanılır, kişisel veri taşımaz.
const SESSION_KEY = 'activity-session-id';

export const getActivitySessionId = () => {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};
